import React, { Component } from 'react';
import styled from 'styled-components';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import FilterBlock from './FilterBlock';

class MenuFilters extends Component {
    constructor() {
        super();
        this.state = {
            isArrowLeftVisible: false,
            isArrowRightVisible: true,
        };

        this.checkOffset = this.checkOffset.bind(this);
    }

    componentDidMount() {
        const { sliderRef } = this.props;
        if (sliderRef === undefined) return;
        const screenWidth = sliderRef.current.clientWidth;
        const fullWidth = sliderRef.current.scrollWidth;

        if (screenWidth === fullWidth) {
            this.setState({ isArrowLeftVisible: false, isArrowRightVisible: false });
        }
    }

    checkOffset() {
        const { sliderRef } = this.props;

        const currenScroll = sliderRef.current.scrollLeft;
        const fullWidth = sliderRef.current.scrollWidth;
        const screenWidth = sliderRef.current.clientWidth;
        const width = fullWidth - screenWidth;

        if (currenScroll > 0) {
            this.setState({ isArrowLeftVisible: true });
        } else {
            this.setState({ isArrowLeftVisible: false });
        }

        if (currenScroll >= width - 32) {
            // 32 это 16 + 16 - оступы по бокам контента
            this.setState({ isArrowRightVisible: false });
        } else {
            this.setState({ isArrowRightVisible: true });
        }
    }

    render() {
        const {
            className,
            handleSwitchFilter,
            filters = [],
            sliderWrapperRef,
            sliderRef,
        } = this.props;
        const { isArrowLeftVisible, isArrowRightVisible } = this.state;

        return (
            <SliderWrapper className={className} ref={sliderWrapperRef}>
                <ArrowLeft isVisible={isArrowLeftVisible} />
                <Slider ref={sliderRef} onScroll={this.checkOffset}>
                    {
                        filters.map(({ name, isActive }, index) => (
                            <FilterBlockStyled
                                key={index.toString()}
                                isActive={isActive}
                                handleSwitchFilter={() => handleSwitchFilter(name)}
                            >
                                {name}
                            </FilterBlockStyled>
                        ))
                    }
                </Slider>
                <ArrowRight isVisible={isArrowRightVisible} />
            </SliderWrapper>
        );
    }
}

const SliderWrapper = styled.div`
    position: relative;
`;

const Slider = styled.div`
    display: flex;

    overflow-x: scroll;
    scroll-behavior: smooth;
    scrollbar-width: none;
    white-space: nowrap;

    /* margin-left: 25px; */

    ::-webkit-scrollbar {
        display: none;
        scrollbar-width: none;
    }

    ::-moz-scrollbar {
        scrollbar-width: none;
    }
`;

const FilterBlockStyled = styled(FilterBlock)`
    margin-right: 17px;

    ${mediaWidth.m} {
        margin-right: 9px;
    }

    ${mediaWidth.l} {
        margin-right: 20px;
    }

    ${mediaWidth.xl} {
        margin-right: 32px;
    }

    :hover {
        color: #0032A0;
    }

    :active {
        color: #002679;
    }
`;

const ArrowRight = styled.div`
    width: 15px;
    height: 100%;
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    /* display: block; */

    position: absolute;
    right: -1px;
    bottom: 0;

    background: linear-gradient(270deg, #FFFFFF 55.18%, rgba(255, 255, 255, 0) 100%);

    -webkit-tap-highlight-color: rgba(0,0,0,0);
`;

const ArrowLeft = styled(ArrowRight)`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    /* display: none; */
    left: -1px;
    transform: rotate(180deg);
`;

export default MenuFilters;
